export enum StatusState {
  positive = 'positive',
  negative = 'negative',
  neutral = 'neutral',
}

export enum StatusVariant {
  primary = 'primary',
  secondary = 'secondary',
}

export enum StatusType {
  text = 'text',
  icon = 'icon',
}

export interface StatusProps {
  status?: StatusState;
  variant?: StatusVariant;
  type?: StatusType;
  text?: string;
  className?: string;
  showDot?: boolean;
}
